export const setActionPayload = (actionName: string, actionPayload: string) => {
  window.localStorage.setItem(actionName, actionPayload);
};
export const getActionPayload = (actionName: string) => {
  return window.localStorage.getItem(actionName) ?? undefined;
};
